export default __webpack_public_path__ + "static/media/Lola 9781408316801.fe3dd5b6.jpg";